
import React from "react";
import "../styles/hero.css";

export default function Hero() {
  return (
    <section id="home" className="hero">
      <img
        src="0OVqG8jnoiVtGBhXr-EqtaRv.jpeg"
        alt="Happy Seniors Family"
      />

      <div className="hero-content">
        <div className="hero-left">
          <h1 className="hero-heading">Your Service Our Commitment</h1>
        </div>

        <div className="hero-right">
          <h2 className="hero-company">HomoDial Healthcare</h2>
          <p className="hero-subtext">100,000+ Seniors have chosen HomoDial</p>
          <a
            href="https://wa.me/917253815103?text=Hello%20HomoDial,%20how%20can%20I%20book%20an%20appointment?"
            target="_blank"
            rel="noopener noreferrer"
            className="hero-btn"
          >
            Book Appointment

          </a>
        </div>
      </div>
    </section>
  );
}
